

var timeFormat = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
};


/**
 * Returns a timestamp as a standard formatted string. The date format is given
 * above.
 * If `timestamp` is not given, the current time is used.
 */
export default function (timestamp) {
  var date;

  if (timestamp) {
    date = new Date(timestamp * 1000);
  } else {
    date = new Date();
  }


  return date.toLocaleDateString(undefined, timeFormat)
};

